import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import {
  FETCH_STUDENT_TEST_FAILURE, FETCH_STUDENT_TEST_RESULT, FETCH_STUDENT_TEST_SUCCESS,
  FETCH_TEACHER_CREATED_TEST, FETCH_TEACHER_CREATED_TEST_FAILURE, FETCH_TEACHER_CREATED_TEST_SUCCESS, FETCH_TESTS_REQUEST,
  FETCH_TESTS_SUCCESS, SUBMIT_TEST, TEST_SUBMIT_FAILURE, TEST_SUBMIT_SUCCESS, TEMP_DELETE_TEST_DATA,
  FETCH_TEACHER_CREATED_TEST_IN_BIN, FETCH_TEACHER_CREATED_TEST_IN_BIN_FAILURE, FETCH_TEACHER_CREATED_TEST_IN_BIN_SUCCESS,
  RESTORE_DELETE_TEST_DATA, DELETE_TEST_DATA, DELETE_TEST_DATA_FALIURE_MESSAGE, DELETE_TEST_DATA_SUCCESS_MESSAGE, RESTORE_DELETE_TEST_DATA_FALIURE_MESSAGE, RESTORE_DELETE_TEST_DATA_SUCCESS_MESSAGE, TEMP_DELETE_TEST_DATA_FAILURE_MESSAGE, TEMP_DELETE_TEST_DATA_SUCCESS_MESSAGE,
  FETCH_TESTS_FAILURE,
  FETCH_TEST_BY_ID,
  FETCH_TEST_BY_ID_SUCCESS,
  FETCH_TEST_BY_ID_FAILURE,
  UPDATE_TEST_BY_ID_SUCCESS,
  UPDATE_TEST_BY_ID_FAILURE,
  UPDATE_TEST_BY_ID,
  FETCH_TEST_BY_ID_FOR_ALL,
  FETCH_TEST_BY_ID_FOR_ALL_SUCCESS,
  FETCH_TEST_BY_ID_FOR_ALL_FAILURE,
  UPDATE_TEST_REQUEST,
  UPDATE_TEST_FAILURE,
  UPDATE_TEST_SUCCESS
} from '../actions/testActions';
import axiosInstance from '../api/axiosInstance';
// import { DeleteTestDataTemp } from '../actions/dashboardActions';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Worker Saga to fetch user data
function* fetchTestSaga(action) {
  try {
    const { page, limit, category, searchQuery, paginated} = action.payload;
    const params = {
      page,
      limit : paginated ? limit : 0,
      ...(category !== 'All' && { category }),
      ...(searchQuery && { search: searchQuery }),
      paginated: paginated
    };
    // Make a request to fetch user data from the backend with token in headers
    const response = yield call(axiosInstance.get, "/tests", { params });
    const { tests, totalTests } = response.data;
    const totalPages = Math.ceil(totalTests / limit);

    // Dispatch success action with user role
      yield put({
      type: FETCH_TESTS_SUCCESS,
      payload: {
        tests,
        totalPages,
        totalTests,
        currentPage: page
      }
    });
  } catch (error) {
    // Dispatch failure action on error
    yield put({ type: FETCH_TESTS_FAILURE, payload: { error: error.message } });
  }
}


function* handleSubmitTest(action) {
  try {

    const response = yield call(axios.put, `${API_URL}/examsubmit`, action.payload);


    if (response.data) {
      const data = response.data


      yield put({ type: TEST_SUBMIT_SUCCESS, payload: data });
    }
  } catch (error) {
    console.error(error);
    yield put({ type: TEST_SUBMIT_FAILURE });
  }
}


function* fetchStudentResultSaga() {
  try {

    // Make a request to fetch user data from the backend with token in headers
    const response = yield call(axiosInstance.get, "/resulttable");

    const testresultData = response.data;
    // Dispatch success action with user role
    yield put({ type: FETCH_STUDENT_TEST_SUCCESS, payload: testresultData });
  } catch (error) {
    // Dispatch failure action on error
    yield put({ type: FETCH_STUDENT_TEST_FAILURE, payload: { error: error.message } });
  }
}

function* fetchTeacherCreatedTestSaga() {
  try {
    // Make a request to fetch user data from the backend with token in headers
    const response = yield call(axiosInstance.get, "/teachercreatedtest");
    const testresultforTeacher = response.data;

    yield put({ type: FETCH_TEACHER_CREATED_TEST_SUCCESS, payload: testresultforTeacher });
  } catch (error) {

    yield put({ type: FETCH_TEACHER_CREATED_TEST_FAILURE, payload: { error: error.message } });
  }
}

function* fetchTeacherCreatedTestInBinSaga() {
  try {
    // Make a request to fetch user data from the backend with token in headers
    const response = yield call(axiosInstance.get, "/trashdata");
    const testresultforTeacher = response.data;


    yield put({ type: FETCH_TEACHER_CREATED_TEST_IN_BIN_SUCCESS, payload: testresultforTeacher });
  } catch (error) {

    yield put({ type: FETCH_TEACHER_CREATED_TEST_IN_BIN_FAILURE, payload: { error: error.message } });
  }
}

//Deleting the data from the All created test and sending data in Trash. sending testId as a payload
function* deleteTestDataTempSaga(action) {
  try {
    const response = yield call(axios.put, `${API_URL}/deletetest`, action.payload);
    if (response.data) {
      const data = response.data;

      yield put({ type: TEMP_DELETE_TEST_DATA_SUCCESS_MESSAGE, payload: data });
    }

  } catch (error) {
    console.error(error);
    yield put({ type: TEMP_DELETE_TEST_DATA_FAILURE_MESSAGE });
  }
}

//Deleting Test Data Permanently by using the Test Id
function* deleteTestDataPermanentlySaga(action) {
  try {

    const api = `${API_URL}/deletetestpermanently/` + action.payload.testId;

    const response = yield call(axios.delete, api);


    if (response.data) {
      const data = response.data
        ;

      yield put({ type: DELETE_TEST_DATA_SUCCESS_MESSAGE, payload: data });
    }
  } catch (error) {
    console.error(error);
    yield put({ type: DELETE_TEST_DATA_FALIURE_MESSAGE });
  }
}

// Restoring the data from the backend sending testId as a payload
function* restoreTestDataSaga(action) {
  try {
    const response = yield call(axios.put, `${API_URL}/undodeletedtests`, action.payload);

    if (response.data) {
      const data = response.data
      yield put({ type: RESTORE_DELETE_TEST_DATA_SUCCESS_MESSAGE, payload: data });
    }

  } catch (error) {
    console.error(error);
    yield put({ type: RESTORE_DELETE_TEST_DATA_FALIURE_MESSAGE });
  }
}

function* fetchTestByidSaga(action) {
  try {

    // Make a request to fetch test data from the backend with token in headers
    const response = yield call(axiosInstance.get, "/view-test-by-id/" + action.payload);
    const testData = response.data;

    // Dispatch success action with user role
    yield put({ type: FETCH_TEST_BY_ID_SUCCESS, payload: testData });
  } catch (error) {
    // Dispatch failure action on error
    yield put({ type: FETCH_TEST_BY_ID_FAILURE, payload: { error: error.message } });
  }
}

function* handleupdateTestbyidsaga(action) {
  try {

    const response = yield call(axiosInstance.put, "/update-by-id/" + action.payload.testId, action.payload);
    if (response.data) {
      const data = response.data
      yield put({ type: UPDATE_TEST_BY_ID_SUCCESS, payload: data });
    }
  } catch (error) {
    console.error(error);
    yield put({ type: UPDATE_TEST_BY_ID_FAILURE });
  }
}


function* fetchTestByidforallSaga(action) {
  try {

    // Make a request to fetch test data from the backend with token in headers
    const response = yield call(axios.get, `${API_URL}/view-test-by-id-for-all/${action.payload}`);

    const testData = response.data;

    // Dispatch success action with user role
    yield put({ type: FETCH_TEST_BY_ID_FOR_ALL_SUCCESS, payload: testData });
  } catch (error) {
    // Dispatch failure action on error
    yield put({ type: FETCH_TEST_BY_ID_FOR_ALL_FAILURE, payload: { error: error.message } });
  }
}



function* updateTestSaga(action) {
  try {
  const { _id, ...testData } = action.payload;
    
    // Make a request to update test data to the backend with token in headers
    const response = yield call(axiosInstance.put, "/updatetest/" + _id, testData);
   
    yield put({ type: UPDATE_TEST_SUCCESS, payload: response.data });

  } catch (error) {
    // Dispatch failure action on error
    yield put({ type: UPDATE_TEST_FAILURE});
  }
}


// Watcher Saga to trigger fetch user data saga
function* fetchTestDataSaga() {
  yield takeEvery(FETCH_TESTS_REQUEST, fetchTestSaga);
  yield takeEvery(SUBMIT_TEST, handleSubmitTest);
  yield takeEvery(FETCH_STUDENT_TEST_RESULT, fetchStudentResultSaga);
  yield takeEvery(FETCH_TEACHER_CREATED_TEST, fetchTeacherCreatedTestSaga);
  yield takeEvery(TEMP_DELETE_TEST_DATA, deleteTestDataTempSaga);
  yield takeEvery(FETCH_TEACHER_CREATED_TEST_IN_BIN, fetchTeacherCreatedTestInBinSaga);
  yield takeEvery(RESTORE_DELETE_TEST_DATA, restoreTestDataSaga);
  yield takeEvery(DELETE_TEST_DATA, deleteTestDataPermanentlySaga);
  yield takeEvery(FETCH_TEST_BY_ID, fetchTestByidSaga);
  yield takeEvery(UPDATE_TEST_BY_ID, handleupdateTestbyidsaga);
  yield takeEvery(FETCH_TEST_BY_ID_FOR_ALL, fetchTestByidforallSaga);
  yield takeEvery(UPDATE_TEST_REQUEST, updateTestSaga);


}

export default fetchTestDataSaga;
